(() => {
  'use strict';
  const banner = document.getElementById('oe-sale-countdown');
  if (!banner || banner.dataset.initialized) return;
  banner.dataset.initialized = 'true';
  const deadline = Date.parse(banner.dataset.deadline);
  const fields = ['hours', 'minutes', 'seconds'].map(unit => banner.querySelector(`[data-${unit}]`));
  if (!Number.isFinite(deadline) || fields.some(field => !field)) {
    banner.hidden = true;
    return;
  }
  let timeout;
  function update() {
    clearTimeout(timeout);
    const remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
    if (!remaining) {
      banner.hidden = true;
      document.removeEventListener('visibilitychange', update);
      window.removeEventListener('pageshow', update);
      return;
    }
    const values = [Math.floor(remaining / 3600), Math.floor(remaining / 60) % 60, remaining % 60];
    fields.forEach((field, index) => {
      const value = String(values[index]).padStart(2, '0');
      if (field.textContent !== value) field.textContent = value;
    });
    // Recompute from the fixed deadline so background tabs cannot slow the clock.
    if (!document.hidden) timeout = setTimeout(update, 1000 - Date.now() % 1000);
  }
  document.addEventListener('visibilitychange', update);
  window.addEventListener('pageshow', update);
  update();
})();
